import { useEffect } from "react";
import { isRouteErrorResponse, useRevalidator, useRouteError } from "react-router";
import { RotateCcw, TriangleAlert } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

export function DashboardError() {
  const error = useRouteError();
  const revalidator = useRevalidator();

  useEffect(() => {
    console.error(error);
  }, [error]);

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : null;

  return (
    <Empty className="mx-auto my-10 max-w-xl border">
      <EmptyHeader>
        <EmptyMedia variant="icon" className="bg-destructive/10 text-destructive">
          <TriangleAlert />
        </EmptyMedia>
        <EmptyTitle>This page hit an error</EmptyTitle>
        <EmptyDescription>
          Try again — if it keeps happening, share the details below with engineering.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button onClick={() => revalidator.revalidate()} disabled={revalidator.state === "loading"}>
          <RotateCcw /> Try again
        </Button>
        {import.meta.env.DEV && detail ? (
          <p className="text-muted-foreground font-mono text-xs">{detail}</p>
        ) : null}
      </EmptyContent>
    </Empty>
  );
}
